<div *ngIf="ready">
	<app-header></app-header>
	<main id="maincontent" tabindex="-1" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
		<div class="banner" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="12px">
			<img fxHide.gt-md src="assets/img/open_sims_logo_sm.svg" alt="{{'Common.ImageDescriptions.OpenSIMSLogo' | translate}}">
			<img fxHide.lt-lg src="assets/img/open_sims_logo_md.svg" alt="{{'Common.ImageDescriptions.OpenSIMSLogo' | translate}}">
			<span>{{'Home.SubHeader' | translate}}</span>
		</div>

		<mat-card *ngIf="!success">
		<div class="formHeader" fxLayout="column" fxLayoutAlign="center center">
			<h1>{{'SignUp.Title' | translate}}</h1>
			<p>{{'SignUp.SubHeader' | translate}}</p>
		</div>
		<form id="newProgramForm" [formGroup]="signup" #formDirective="ngForm">
			<div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="space-between stretch">
				<div fxLayout="row wrap" fxLayoutAlign="center stretch">
					<mat-form-field id="email">
						<mat-label>{{'SignUp.FIELD_EMAIL' | translate}}</mat-label>
						<input id="Content" matInput maxlength="255" formControlName="email" email required [attr.aria-describedby]="signup.controls['email'].invalid ? 'email-error' : null">
						<mat-error id="email-error" *ngIf="signup.controls['email'].invalid">
							<span *ngIf="signup.controls['email'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_Email' | translate}}</span>
							<span *ngIf="signup.controls['email'].errors.email">{{'SignUp.VALIDATION_ERRORS.FORMAT_Email' | translate}}</span>
						</mat-error>
					</mat-form-field>
					<mat-form-field id="email-confirm">
						<mat-label>{{'SignUp.FIELD_CONFIRM_EMAIL' | translate}}</mat-label>
						<input matInput maxlength="255" formControlName="confirmEmail" email required [attr.aria-describedby]="signup.controls['confirmEmail'].invalid ? 'confirm-email-error' : null">
						<mat-error id="confirm-email-error" *ngIf="signup.controls['confirmEmail'].invalid">
							<span *ngIf="signup.controls['confirmEmail'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_ConfirmEmail' | translate}}</span>
							<span *ngIf="signup.controls['confirmEmail'].errors.email">{{'SignUp.VALIDATION_ERRORS.FORMAT_Email' | translate}}</span>
							<span *ngIf="signup.controls['confirmEmail'].errors.confirmEmail">{{'SignUp.VALIDATION_ERRORS.MATCH_Email' | translate}}</span>
						</mat-error>
					</mat-form-field>
					<mat-form-field id="firstName">
						<mat-label>{{'SignUp.FIELD_FIRSTNAME' | translate}}</mat-label>
						<input matInput maxlength="255" formControlName="firstName" required [attr.aria-describedby]="signup.controls['firstName'].invalid ? 'first-name-error' : null">
						<mat-error id="first-name-error" *ngIf="signup.controls['firstName'].invalid">
							<span *ngIf="signup.controls['firstName'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_FirstName' | translate}}</span>
						</mat-error>
					</mat-form-field>
					<mat-form-field id="lastName">
						<mat-label>{{'SignUp.FIELD_LASTNAME' | translate}}</mat-label>
						<input matInput maxlength="255" formControlName="lastName" required [attr.aria-describedby]="signup.controls['lastName'].invalid ? 'last-name-error' : null">
						<mat-error id="last-name-error" *ngIf="signup.controls['lastName'].invalid">
							<span *ngIf="signup.controls['lastName'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_LastName' | translate}}</span>
						</mat-error>
					</mat-form-field>
					<mat-form-field id="phoneNumber">
						<mat-label>{{'SignUp.FIELD_PHONE' | translate}}</mat-label>
						<input matInput maxlength="255" formControlName="phoneNumber" required [attr.aria-describedby]="signup.controls['phoneNumber'].invalid ? 'phone-number-error' : null">
						<mat-error id="phone-number-error" *ngIf="signup.controls['phoneNumber'].invalid">
							<span *ngIf="signup.controls['phoneNumber'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_Phone' | translate}}</span>
						</mat-error>
					</mat-form-field>
					<mat-form-field id="language">
						<mat-label>{{'SignUp.FIELD_LANGUAGE' | translate}}</mat-label>
						<mat-select formControlName="language" name="language" required [attr.aria-describedby]="signup.controls['language'].invalid ? 'language-error' : null">
							<mat-option>
							</mat-option>
							<mat-option [value]="'SignUp.LANG_EN' | translate">
								{{'SignUp.LANG_EN' | translate}}
							</mat-option>
							<mat-option  [value]="'SignUp.LANG_FR' | translate">
								{{'SignUp.LANG_FR' | translate}}
							</mat-option>												
						</mat-select>
						<mat-error id="language-error" *ngIf="signup.controls['language'].invalid">
							<span *ngIf="signup.controls['language'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_LANGUAGE' | translate}}</span>
						</mat-error>									
					</mat-form-field>					
					<mat-form-field id="organizationType">
						<mat-label>{{'SignUp.FIELD_ORG_TYPE' | translate}}</mat-label>
						<mat-select formControlName="organizationType" name="organizationType" required [attr.aria-describedby]="signup.controls['organizationType'].invalid ? 'organization-type-error' : null" (selectionChange)="organizationTypeChanged()">
							<mat-option>
							</mat-option>
							<mat-option [value]="'SignUp.SEL_COLL' | translate">
								{{'SignUp.SEL_COLL' | translate}}
							</mat-option>
							<mat-option  [value]="'SignUp.SEL_UNI' | translate">
								{{'SignUp.SEL_UNI' | translate}}
							</mat-option>
							<mat-option  [value]="'OPS' | translate">
								{{'SignUp.SEL_OPS' | translate}}
							</mat-option>
							<mat-option  [value]="'OTHER' | translate">
								{{'SignUp.SEL_OTHER' | translate}}
							</mat-option>												
						</mat-select>	
						<mat-error id="organization-type-error" *ngIf="signup.controls['organizationType'].invalid">
							<span *ngIf="signup.controls['organizationType'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_ORGTYPE' | translate}}</span>
						</mat-error>								
					</mat-form-field>
					<mat-form-field id="organization">
						<mat-label>{{'SignUp.FIELD_ORG_NAME' | translate}}</mat-label>
						<mat-select formControlName="organization" name="organization" required [attr.aria-describedby]="signup.controls['organization'].invalid ? 'organization-error' : null" *ngIf="!(signup.controls['organizationType'].value==='OPS' || signup.controls['organizationType'].value==='OTHER')">
							<mat-option *ngFor="let org of filtered; let i = index" [value]="org.name" [matTooltip]="org.displayName" matTooltipShowDelay="1000">
							{{org.displayName}}
							</mat-option>
						</mat-select>
						<input matInput maxlength="255" formControlName="organization" required [attr.aria-describedby]="signup.controls['organization'].invalid ? 'organization-error' : null" *ngIf="(signup.controls['organizationType'].value==='OPS' || signup.controls['organizationType'].value==='OTHER')">
						<mat-error id="organization-error" *ngIf="signup.controls['organization'].invalid">
							<span *ngIf="signup.controls['organization'].errors.required">{{'SignUp.VALIDATION_ERRORS.REQUIRED_ORGNAME' | translate}}</span>
						</mat-error>									
					</mat-form-field>
					<mat-form-field id="reasonForAccess">
						<mat-label>{{'SignUp.FIELD_REASON' | translate}}</mat-label>
						<textarea matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="10" matInput formControlName="reasonForAccess" [attr.aria-describedby]="signup.controls['reasonForAccess'].invalid ? 'reason-for-access-error' : null"></textarea>
						<mat-error id="reason-for-access-error" *ngIf="signup.controls['reasonForAccess'].invalid">
							<span *ngIf="signup.controls['reasonForAccess'].errors.maxlength">{{'SignUp.VALIDATION_ERRORS.MAX_LENGTH' | translate}}</span>
						</mat-error>
					</mat-form-field>		
				</div>
				<div fxLayoutGap="6px">
					<button mat-flat-button color="primary" id="signup" type="submit" (click)="signUp()" [disabled]="isSaving || signup.invalid">
						{{'SignUp.CONFIRM_BUTTON' | translate}}
					</button>
					<button mat-flat-button color="primary" id="cancel" type="button" (click)="cancel()">
						{{'SignUp.CANCEL_BUTTON' | translate}}
					</button>
				</div>
			</div>
		</form>
	</mat-card>
	<span class="recaptcha-notice" role="note">
		{{'SignUp.RECAPTCHA_NOTICE_SiteProtected' | translate}}
		<a href="https://policies.google.com/privacy{{'SignUp.RECAPTCHA_NOTICE_FrenchLocalizationParam' | translate}}" target="_blank" rel="noopener noreferrer" title="{{'Common.Notifications.OpensInNewWindow' | translate}}">{{'SignUp.RECAPTCHA_NOTICE_PrivacyPolicy' | translate}}</a>
		{{'SignUp.RECAPTCHA_NOTICE_And' | translate}}
		<a href="https://policies.google.com/terms{{'SignUp.RECAPTCHA_NOTICE_FrenchLocalizationParam' | translate}}" target="_blank" rel="noopener noreferrer" title="{{'Common.Notifications.OpensInNewWindow' | translate}}">{{'SignUp.RECAPTCHA_NOTICE_TermsOfService' | translate}}</a>
		{{'SignUp.RECAPTCHA_NOTICE_Apply' | translate}}
	</span>
	</main>
	<app-footer></app-footer>
</div>